/**
 * Shared body-level portal containers for dropdown/modal overlays.
 * Reference-counted so route changes don't remove portals still in use.
 */

let refCount = 0;
let dropdownPortalEl = null;
let modalPortalEl = null;

const DROPDOWN_PORTAL_ID = "dropdown-portal";
const MODAL_PORTAL_ID = "modal-portal";

function isManagedBodyPortal(el) {
  return el && el.parentNode === document.body;
}

function ensureBodyPortal(id) {
  const existing = document.getElementById(id);
  if (isManagedBodyPortal(existing)) {
    return existing;
  }
  const el = document.createElement("div");
  el.id = id;
  document.body.appendChild(el);
  return el;
}

function safeRemove(el) {
  try {
    if (el?.parentNode) {
      el.parentNode.removeChild(el);
    }
  } catch {
    // Already removed or moved — ignore.
  }
}

export function setupPortalContainers() {
  refCount += 1;
  if (refCount === 1) {
    dropdownPortalEl = ensureBodyPortal(DROPDOWN_PORTAL_ID);
    modalPortalEl = ensureBodyPortal(MODAL_PORTAL_ID);
  }
}

export function teardownPortalContainers() {
  refCount = Math.max(0, refCount - 1);
  if (refCount === 0) {
    safeRemove(dropdownPortalEl);
    safeRemove(modalPortalEl);
    dropdownPortalEl = null;
    modalPortalEl = null;
  }
}

export function getDropdownPortalTarget() {
  return (
    dropdownPortalEl ||
    document.getElementById(DROPDOWN_PORTAL_ID) ||
    document.body
  );
}

export function getModalPortalTarget() {
  return (
    modalPortalEl || document.getElementById(MODAL_PORTAL_ID) || document.body
  );
}
